<template>
  <!-- Undo a cancellation (superadmin): asks the reason, like CancelOrderModal -->
  <BaseModal :value="true" class="reactivate-order" @input="$emit('close')">
    <template v-slot:header>
      <h1>{{ $t("message.order.reactivate_order") }}</h1>
    </template>
    <div class="rounded-md flex flex-col justify-center">
      <p class="mb-3">{{ $t("message.order.reactivate_order_help") }}</p>
      <label for="reactivate-reason">{{
        $t("message.order.reactivate_reason")
      }}</label>
      <textarea
        id="reactivate-reason"
        class="bordered regular full h-32"
        v-model="reason"
        rows="6"
      ></textarea>
      <div class="flex flex-row justify-end mt-4 gap-2">
        <button
          class="btn btn-success-button"
          :disabled="saving || !reason.trim()"
          @click="$emit('proceed', reason.trim())"
        >
          {{
            saving ? $t("message.order.saving") : $t("message.order.reactivate")
          }}
        </button>
        <button
          class="btn btn-dark-button"
          :disabled="saving"
          @click="$emit('close')"
        >
          {{ $t("message.order.cancel") }}
        </button>
      </div>
    </div>
  </BaseModal>
</template>
<script>
export default {
  name: "ReactivateOrderModal",
  props: {
    saving: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      reason: ""
    };
  }
};
</script>
<style>
.reactivate-order .modal-content {
  width: 90% !important;
  max-width: 400px !important;
  height: auto !important;
}
</style>
